@if (loadingSignal()) {
  <div class="logo-container">
    <div class="d-flex d-flex-column justify-center align-center position-relative">
      <div class="d-flex d-flex-row justify-center align-center position-relative">
        <div class="logo"></div>
        <div class="title">
          CUSTODY
        </div>
      </div>
      <div class="d-block w-100 p-1">
        <mat-progress-bar mode="indeterminate" color="accent"/>
      </div>
    </div>

  </div>
}
<router-outlet></router-outlet>
